<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg2">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-content">
          <h2>Services Details</h2>

          <ul>
            <li><a href="#">Home</a></li>
            <li>Services Details</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="shape-img2"><img src="assets/img/shape/2.svg" alt="image" /></div>
  <div class="shape-img3"><img src="assets/img/shape/3.svg" alt="image" /></div>
  <div class="shape-img4"><img src="assets/img/shape/4.png" alt="image" /></div>
  <div class="shape-img5"><img src="assets/img/shape/5.png" alt="image" /></div>
  <div class="shape-img7"><img src="assets/img/shape/7.png" alt="image" /></div>
  <div class="shape-img8"><img src="assets/img/shape/8.png" alt="image" /></div>
  <div class="shape-img9"><img src="assets/img/shape/9.png" alt="image" /></div>
  <div class="shape-img10">
    <img src="assets/img/shape/10.png" alt="image" />
  </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area ptb-100">
  <div class="container">
    <div class="services-details-overview">
      <div class="services-details-desc">
        <h3>Cross-channel conversations</h3>
        <p>
          While traditional communication channels have largely been
          unidirectional, Enaiko conversations converts these unidirectional
          channels into meaningful two-way conversations. These conversations
          are powered by modern large language models. You have full control
          over the data you use to customize the foundation models for your
          generative AI conversations. This means your data is not shared with
          model providers and is not used to improve the base models. Enaiko
          guardrails ensure accurate responses and protect PII by filtering data
          using regex patterns.
        </p>

        <div class="features-text">
          <h4>Live Agent Support</h4>
          <p>
            Enaiko enables user creation and assigns them to relevant
            departments. When conversations are handed over to a live agent,
            they are accompanied by an AI-generated summary. Agents can
            seamlessly continue the conversation through the same originating
            channels and assist customers. Additionally, Enaiko integrates with
            calendar solutions to manage appointment requests.
          </p>
        </div>
        <!--
                <div class="features-text">
                    <h4><i class="flaticon-tick"></i> Data</h4>
                    <p>Enaiko's custom data platform enriches this overall capability.
                    </p>
                </div> -->
      </div>

      <div class="services-details-image wow fadeInUp">
        <!-- <img src="assets/img/about-img1.png" alt="image"> -->
        <img
          src="https://enaikoimages.s3.amazonaws.com/CrossChannelMarketing_830x750.png"
          alt="image"
        />
      </div>
    </div>

    <div class="services-details-overview">
      <div class="services-details-image wow fadeInUp">
        <img src="assets/img/why-choose-img1.png" alt="image" />
      </div>

      <div class="services-details-desc">
        <h3>Marketing and Conversational Analytics</h3>
        <p>
          Delivers metrics on campaign performance, including open rates and
          click-throughs. Conversational Analytics monitors the effectiveness of
          the LLM agent and tracks live agent performance.
        </p>

        <div class="services-details-accordion">
          <ul class="accordion">
            <li class="accordion-item">
              <a class="accordion-title active" href="javascript:void(0)">
                <i class="fas fa-plus"></i>
                When are we planning to launch?
              </a>

              <p class="accordion-content show">
                We expect to launch early by November 2024.
              </p>
            </li>

            <li class="accordion-item">
              <a class="accordion-title" href="javascript:void(0)">
                <i class="fas fa-plus"></i>
                What will be the pricing model?
              </a>

              <p class="accordion-content">
                The pricing will be competitive across all markets.It will be a
                combination of tiered pricing and pay-per-use features.
              </p>
            </li>

            <li class="accordion-item">
              <a class="accordion-title" href="javascript:void(0)">
                <i class="fas fa-plus"></i>
                Will we be interested in feed back to enrich build?
              </a>

              <p class="accordion-content">
                We actively look forward to comments and feedback and will
                provide early beta access to customers who want to take it out
                for a drive. Please email admin&#64;enaiko.com to be part of the
                early pilot program.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Services Details Area -->
